import {CanBeSignal, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {ActionFunction} from './Wrap';

export function Alpha(alpha: CanBeSignal<number>): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        instance.alpha = getProp(alpha);
        done();
    };

    return result;
};
